import { render, staticRenderFns } from "./ImportFileUpload.vue?vue&type=template&id=2140bfa6"
import script from "./ImportFileUpload.vue?vue&type=script&lang=js"
export * from "./ImportFileUpload.vue?vue&type=script&lang=js"
import style0 from "./ImportFileUpload.vue?vue&type=style&index=0&id=2140bfa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports